import { upsertCapacityFilter } from '@dispatch/shared/services';
import { CapacityFilterResponse } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertCapacityFilter = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-capacity-filter'],
    (data: CapacityFilterResponse) =>
      upsertCapacityFilter(
        {
          ...data,
          userId,
        },
        userId
      ),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertCapacityFilter: mutate,
    upsertCapacityFilterError: error,
    upsertCapacityFilterStatus: status,
  };
};
